import { render, staticRenderFns } from "./ColorModuleHeader.vue?vue&type=template&id=e3b8dae4&scoped=true"
import script from "./ColorModuleHeader.vue?vue&type=script&lang=ts"
export * from "./ColorModuleHeader.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleHeader.vue?vue&type=style&index=0&id=e3b8dae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b8dae4",
  null
  
)

export default component.exports